<template>
  <div id="app-company-icon-menu-group" class="app-company-icon-menu-group">
    <AppIconMenuGroup>
      <AppIconMenu
        v-for="(item, index) in menuProperties"
        :key="index"
        :index="index"
        :icon-path="iconDataArray[index].icon"
        :text="iconDataArray[index].text"
        :has-un-read-event="item.hasUnReadEvent"
        :href="item.href"
        :selected-menu-index="selectedMenuIndex"
        @clicked-icon="updateSelectedMenuIndex"
      />
    </AppIconMenuGroup>
  </div>
</template>

<script>
import AppIconMenu from './components/AppIconMenu';
import AppIconMenuGroup from './components/AppIconMenuGroup';
export default {
  name: 'AppCompanyIconMenu',
  components: {
    AppIconMenu,
    AppIconMenuGroup,
  },
  props: {
    menuProperties: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      iconDataArray: [
        { icon: 'top', text: 'トップ' },
        { icon: 'selection-steps', text: '選考ステップ' },
        { icon: 'reviews', text: 'クチコミ' },
        { icon: 'events', text: 'イベント' },
        { icon: 'entry-sheets', text: 'ES' },
        { icon: 'experiences', text: '体験談' },
        { icon: 'selection-points', text: '合格の秘訣' },
      ],
      selectedMenuIndex: 0,
    };
  },
  computed: {
    isEntrySheetsPath() {
      const middle_categories = location.search
        .split('&')
        .filter((e) => e.includes('middle_categories'))
        .map((s) => s.slice(-'entry_sheet'.length));
      // middle_categoriesがentry_sheetのみで絞られている場合
      return middle_categories.length === 1 && middle_categories.includes('entry_sheet');
    },
    isExperiencesPath() {
      return location.pathname.includes('experiences');
    },
    isSelectionPointsPath() {
      return location.hash.includes('selection-points');
    },
    isTopPath() {
      return /\/companies\/\d+($|\/$|#$)/.test(location.pathname);
    },
  },
  created() {
    this.initializeSelectedMenuIndex();
  },
  methods: {
    initializeSelectedMenuIndex() {
      // パスに該当するメニューを探す
      const index = this.menuProperties.findIndex((e, i) => {
        if (this.isTopPath) return i === 0;
        else if (this.isEntrySheetsPath) return i === 4;
        else if (this.isExperiencesPath) return i === 5;
        else if (this.isSelectionPointsPath) return i === 6;
        else return e.href.includes(location.pathname.replace(/\/$/, ''));
      });
      this.updateSelectedMenuIndex(index);
    },
    updateSelectedMenuIndex(index) {
      this.selectedMenuIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-company-icon-menu-group {
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: -16px;
  margin-left: -8px;
  margin-right: -8px;
  @media screen and (min-width: 768px) {
    display: none;
  }
}
</style>
